import React, { useEffect } from "react";
import { Form, Input, Checkbox, Typography } from "antd";
import { UsimTypeItem } from "../../../../api/usim/uploads/products/usimTypeItem";

const { Text } = Typography;

interface ProductTypeFormProps {
  isEdit?: boolean;
  productType?: UsimTypeItem | null;
  onSubmit: (values: { name: string; iccid: boolean , activationDate?: boolean }) => Promise<void>;
  onCancel?: () => void;
}

const ProductTypeForm: React.FC<ProductTypeFormProps> = ({
  isEdit = false,
  productType,
  onSubmit,
  onCancel,
}) => {
  const [form] = Form.useForm();

  // Pre-fill form when editing or reset when adding
  useEffect(() => {
    if (isEdit && productType) {
      form.setFieldsValue({
        name: productType.name,
        iccid: productType.iccid,
        activationDate: productType.activationDate,
      });
    } else {
      // Reset form for new entries and set default values
      form.resetFields();
      form.setFieldsValue({
        name: "",
        iccid: false,
        activationDate: false,
      });
    }
  }, [isEdit, productType, form]);

  const handleSubmit = async (values: UsimTypeItem) => {
    try {
      console.log("values", values)
      await onSubmit(values);
      if (!isEdit) {
        // Only reset form after successful submission for add mode
        form.resetFields();
        form.setFieldsValue({
          name: "",
          iccid: false,
          activationDate: false,
        });
      }
    } catch (error) {
      console.error("Form submission failed:", error);
    }
  };

  return (
    <Form 
      form={form} 
      layout="vertical" 
      onFinish={handleSubmit}
      initialValues={{
        name: "",
        iccid: false,
        activationDate: false,
      }}
    >
      <Form.Item
        label="Product Type"
        name="name"
        rules={[
          { required: true, message: "Product type is required" },
          { whitespace: true, message: "Product type cannot be empty" }
        ]}
      >
        <Input 
          placeholder="Enter product type" 
          allowClear
        />
      </Form.Item>
      
      <Typography.Text>Name Convention:</Typography.Text>
      <br />
      <Typography.Text type="secondary">
        Local Products - Operator [Country] Ex: Turkey [Vodafone]
      </Typography.Text>
      <br />
      <Typography.Text type="secondary">
        Blank SIMs/Loadable SIMs - [Supplier] SIM Name Ex: [JT] T-Mobile
      </Typography.Text>
      <br />
      <br />

      <Form.Item
        label="Has ICCID"
        name="iccid"
        valuePropName="checked"
      >
        <Checkbox>Product requires ICCID</Checkbox>
      </Form.Item>
      <Form.Item
        label="Activation Date"
        name="activationDate"
        valuePropName="checked"
      >
        <Checkbox>Product requires activation date</Checkbox>
      </Form.Item>

      {/* Hidden submit button - will be triggered by parent */}
      <button type="submit" style={{ display: "none" }} />
    </Form>
  );
};

export default ProductTypeForm;